"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePure = void 0;
var react_1 = __importDefault(require("react"));
var debug_1 = __importDefault(require("debug"));
var utils_1 = require("../utils");
var extendHOC_1 = __importDefault(require("./extendHOC"));
var utils_2 = require("./utils");
function makePure(_a) {
    var maxDepth = _a.maxDepth, excludedKeys = _a.excludedKeys;
    return function (WrappedComponent) {
        var debug = debug_1.default("app:pure:" + utils_1.getDisplayName(WrappedComponent));
        var Pure = /** @class */ (function (_super) {
            __extends(Pure, _super);
            function Pure() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Pure.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                var isEqual = process.env.NODE_ENV === 'development'
                    ? utils_2.checkEqualityAndMeasurePerf
                    : utils_2.checkEquality;
                var checkEqualityOptions = {
                    maxDepth: maxDepth,
                    excludedKeys: excludedKeys,
                    debug: debug,
                };
                var result = !isEqual(this.props, nextProps, checkEqualityOptions) ||
                    !isEqual(this.state, nextState, checkEqualityOptions);
                debug('shouldComponentUpdate', (result ? 'HAS' : 'NOT') + " changed", {
                    prevProps: this.props,
                    nextProps: nextProps,
                    prevState: this.state,
                    nextState: nextState,
                });
                return result;
            };
            Pure.prototype.render = function () {
                return react_1.default.createElement(WrappedComponent, __assign({}, this.props));
            };
            return Pure;
        }(react_1.default.Component));
        return extendHOC_1.default(WrappedComponent, Pure);
    };
}
exports.makePure = makePure;
var defaultCfg = {
    maxDepth: 2,
    excludedKeys: [],
};
var withPure = makePure(defaultCfg);
exports.default = withPure;
//# sourceMappingURL=withPure.js.map